import React, { useState } from "react";
import PayInDashboard from "./PayInDashboard";
import PayOutDashboard from "./PayOutDashboard";
import RefundsDashboard from "./RefundsDashboard";
import { AccountStatusSearch } from "../../components/AccountStatusSearch/AccountStatusSearch";
import { TestAccountBanner } from "../../components";
import { isPartnerRole } from "../../utils/roleUtils";
import theme from "../../themes/dark-theme";

const DashboardController = () => {
  const [activeDashboard, setActiveDashboard] = useState("payout");
  const userFirstName = localStorage.getItem("userFirstName");
  const userRole = localStorage.getItem("userRole");
  
  // Set initial dashboard based on role
  React.useEffect(() => {
    if (userRole === "partner-support") {
      setActiveDashboard("account-status");
    }
  }, [userRole]);
  
  return (
    <section className="m-2 md:m-10 pl-10 mt-24 p-2 md:p-10" style={{ backgroundColor: theme.colors.background.primary, minHeight: '100vh' }}>
      <TestAccountBanner />
      <div className="w-full flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-semibold" style={{ color: theme.colors.text.primary }}>
            Hello {userFirstName}
          </h1>
          <p className="text-sm font-thin mt-2" style={{ color: theme.colors.text.primary }}>
            Find here all your activity stats
          </p>
        </div>
      </div>

      <br />

      <div className="dashboard-container">
      <div className="dashboard-switcher flex space-x-4 mb-6">
        {isPartnerRole(userRole) && (
          <>
            <button
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeDashboard === "payout"
                  ? "bg-[#151821] text-white"
                  : "bg-[#2a2e39] text-gray-300 hover:bg-[#151821] hover:text-white"
              }`}
              onClick={() => setActiveDashboard("payout")}
            >
              Outflow
            </button>
            <button
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeDashboard === "payin"
                  ? "bg-[#151821] text-white"
                  : "bg-[#2a2e39] text-gray-300 hover:bg-[#151821] hover:text-white"
              }`}
              onClick={() => setActiveDashboard("payin")}
            >
              Inflow
            </button>
            <button
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeDashboard === "refunds"
                  ? "bg-[#151821] text-white"
                  : "bg-[#2a2e39] text-gray-300 hover:bg-[#151821] hover:text-white"
              }`}
              onClick={() => setActiveDashboard("refunds")}
            >
              Refunds
            </button>
            <button
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeDashboard === "account-status"
                  ? "bg-[#151821] text-white"
                  : "bg-[#2a2e39] text-gray-300 hover:bg-[#151821] hover:text-white"
              }`}
              onClick={() => setActiveDashboard("account-status")}
            >
              Account Status Search
            </button>
          </>
        )}
        
        {/* Only show Account Status Search for partner-support role */}
        {userRole === "partner-support" && (
          <button
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              activeDashboard === "account-status"
                ? "bg-[#151821] text-white"
                : "bg-[#2a2e39] text-gray-300 hover:bg-[#151821] hover:text-white"
            }`}
            onClick={() => setActiveDashboard("account-status")}
          >
            Account Status Search
          </button>
        )}
      </div>

      <div className="dashboard-content" style={{ backgroundColor: theme.colors.background.primary, minHeight: '100vh' }}>
        {activeDashboard === "payout" && isPartnerRole(userRole) && <PayOutDashboard />}
        {activeDashboard === "payin" && isPartnerRole(userRole) && <PayInDashboard />}
        {activeDashboard === "refunds" && isPartnerRole(userRole) && <RefundsDashboard />}
        {activeDashboard === "account-status" && (isPartnerRole(userRole) || userRole === "partner-support") && <AccountStatusSearch />}
      </div>
    </div>
    </section>
  )
};

export default DashboardController;